import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { ActionItemSkeleton } from '../../../../common/ui/action-item-skeleton';

const styles = cssMap({
	actionContainerStyles: {
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
		width: '100%',
	},
});

interface Props {
	testId?: string;
	actionSize?: number;
}

export const ConversationActionsSkeleton = (props: Props): React.JSX.Element | null => {
	const { testId, actionSize = 3 } = props;

	if (actionSize === 0) {
		return null;
	}

	return (
		<Box xcss={styles.actionContainerStyles} testId={testId}>
			<Stack>
				{Array.from({ length: actionSize }, (_, index) => {
					return <ActionItemSkeleton key={index} />;
				})}
			</Stack>
		</Box>
	);
};
